import React, { useState } from "react";
import trans from "../../../../utils";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";
import { Input } from "../../../Helpers/Input/Input";
import { useGetIRenumsQuery } from "../../../../Redux/service/IR/IR";
import {
  useGetPOIFormQuery,
  useGetPOIProjectsQuery,
  useGetPOIZonesByParentIdQuery,
} from "../../../../Redux/service/POIS/POIs";
import { InputDate } from "../../../Helpers/Input/Input";
import dayjs from "dayjs"; // 👈 important
import SnagLocationSelectorModal from "../../../snagLocation/SnagLocationSelectorModal";
import Button from "../../../Helpers/Button/Button";

export default function IRInformation({
  addData,
  preselectedLocation = null,
  isEditing = false,
}) {
  const [showLocationModal, setShowLocationModal] = useState(false);
  const { data: enums } = useGetIRenumsQuery();
  const { data: projects } = useGetPOIProjectsQuery();
  const { data: zones } = useGetPOIZonesByParentIdQuery(
    {
      id: addData.values.project_id,
    },
    { skip: !addData.values.project_id },
  );

  // ✅ ADD THIS - Fetch levels by zone
  const { data: levels } = useGetPOIZonesByParentIdQuery(
    {
      id: addData.values.zone_id,
    },
    { skip: !addData.values.zone_id },
  );

  // ✅ ADD THIS - Fetch rooms by level
  const { data: rooms } = useGetPOIZonesByParentIdQuery(
    {
      id: addData.values.level_id,
    },
    { skip: !addData.values.level_id },
  );

  // Check if location is preselected
  const isLocationPreselected = !!preselectedLocation;

  // Helper functions to get display names
  const getProjectName = () => {
    const projectId =
      addData.values.project_id || preselectedLocation?.project_id;
    if (!projectId) return "";
    if (preselectedLocation?.project_name)
      return preselectedLocation.project_name;
    const project = projects?.data?.find((p) => p.id === projectId);
    return project?.name || "";
  };

  const getZoneName = () => {
    const zoneId = addData.values.zone_id || preselectedLocation?.zone_id;
    if (!zoneId) return "";
    if (preselectedLocation?.zone_name) return preselectedLocation.zone_name;
    const zone = zones?.data?.find((z) => z.id === zoneId);
    return zone?.name || "";
  };

  const getLevelName = () => {
    const levelId = addData.values.level_id || preselectedLocation?.building_id;
    if (!levelId) return "";
    if (preselectedLocation?.building_name)
      return preselectedLocation.building_name;
    const level = levels?.data?.find((l) => l.id === levelId);
    return level?.name || "";
  };

  const getRoomName = () => {
    const roomId = addData.values.room_id || preselectedLocation?.level;
    if (!roomId) return "";
    if (preselectedLocation?.space_name) return preselectedLocation.space_name;
    const room = rooms?.data?.find((r) => r.id === roomId);
    return room?.name || "";
  };

  // Handle location change from modal
  const handleLocationChange = (locationData) => {
    addData.setFieldValue("project_id", locationData.project_id);
    addData.setFieldValue("zone_id", locationData.zone_id);
    addData.setFieldValue("level_id", locationData.building_id); // building_id maps to level_id
    addData.setFieldValue("room_id", locationData.level); // level (space poiId) maps to room_id
    setShowLocationModal(false);
  };
  // const { data: forms } = useGetAllformsQuery({
  // 	page: 1,
  // 	limit: 10000,
  // 	queryString: "category=IR",
  // });
  const { data: Forms } = useGetPOIFormQuery(
    {
      category: addData.values.type,
      poiId: addData.values.project_id,
    },
    { skip: !addData.values.type || !addData.values.project_id },
  );
  return (
    <div>
      <p className="fs-16 fw-500 brand-700 text-capitalize">
        {trans("general information")}
      </p>
      {isLocationPreselected ? (
        <>
          <div className="row">
            <div className="col-lg-6">
              <Input
                title={trans("Project")}
                type="text"
                formstyle="form-input"
                id="project_id_display"
                name="project_id_display"
                value={getProjectName()}
                disabled={true}
              />
            </div>
            <div className="col-lg-6">
              <Input
                title={trans("Zone")}
                type="text"
                formstyle="form-input"
                id="zone_id_display"
                name="zone_id_display"
                value={getZoneName()}
                disabled={true}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <Input
                title={trans("Level")}
                type="text"
                formstyle="form-input"
                id="level_id_display"
                name="level_id_display"
                value={getLevelName()}
                disabled={true}
              />
            </div>
            <div className="col-lg-6">
              <Input
                title={trans("Room")}
                type="text"
                formstyle="form-input"
                id="room_id_display"
                name="room_id_display"
                value={getRoomName()}
                disabled={true}
              />
            </div>
          </div>
          {/* Change Location Button */}
          <div className="row mt-3">
            <div className="col-12">
              <Button type="default" onClick={() => setShowLocationModal(true)}>
                {trans("Change Location")}
              </Button>
            </div>
          </div>
          {/* Hidden fields to store actual IDs for submission */}
          <input
            type="hidden"
            name="project_id"
            value={addData.values.project_id}
          />
          <input type="hidden" name="zone_id" value={addData.values.zone_id} />
          <input
            type="hidden"
            name="level_id"
            value={addData.values.level_id}
          />
          <input type="hidden" name="room_id" value={addData.values.room_id} />
        </>
      ) : (
        <>
          <div className="row">
            <div className="col-lg-6">
              <InputSelect
                label="projects"
                name="project_id"
                id="project_id"
                options={projects?.data?.map((i) => ({
                  label: i.name,
                  value: i.id,
                }))}
                placeholder={trans(`Select Project`)}
                formstyle="form-input"
                onBlur={(e) => addData.handleBlur(e)}
                onChange={(value) => addData.setFieldValue("project_id", value)}
                value={addData.values.project_id}
                allowClear={false}
                touched={addData.touched.project_id}
                errors={addData.errors.project_id}
                disabled={isEditing}
              />
            </div>
            <div className="col-lg-6">
              <InputSelect
                label="zones"
                name="zone_id"
                id="zone_id"
                options={zones?.data?.map((i) => ({
                  label: i.name,
                  value: i.id,
                }))}
                placeholder={trans(`Select Zone`)}
                formstyle="form-input"
                onBlur={(e) => addData.handleBlur(e)}
                onChange={(value) => {
                  addData.setFieldValue("zone_id", value);
                  addData.setFieldValue("level_id", null); // ✅ Reset level when zone changes
                  addData.setFieldValue("room_id", null); // ✅ Reset room when zone changes
                }}
                value={addData.values.zone_id}
                allowClear={false}
                touched={addData.touched.zone_id}
                errors={addData.errors.zone_id}
                disabled={isEditing}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <InputSelect
                label="level"
                name="level_id"
                id="level_id"
                options={levels?.data?.map((i) => ({
                  label: i.name,
                  value: i.id,
                }))}
                placeholder={trans(`Select Level`)}
                formstyle="form-input"
                onBlur={(e) => addData.handleBlur(e)}
                onChange={(value) => {
                  addData.setFieldValue("level_id", value);
                  addData.setFieldValue("room_id", null); // ✅ Reset room when level changes
                }}
                value={addData.values.level_id}
                allowClear={true}
                touched={addData.touched.level_id}
                errors={addData.errors.level_id}
                disabled={!addData.values.zone_id || isEditing} // ✅ Disable if no zone selected
              />
            </div>
            <div className="col-lg-6">
              <InputSelect
                label="room"
                name="room_id"
                id="room_id"
                options={rooms?.data?.map((i) => ({
                  label: i.name,
                  value: i.id,
                }))}
                placeholder={trans(`Select Room`)}
                formstyle="form-input"
                onBlur={(e) => addData.handleBlur(e)}
                onChange={(value) => addData.setFieldValue("room_id", value)}
                value={addData.values.room_id}
                allowClear={true}
                touched={addData.touched.room_id}
                errors={addData.errors.room_id}
                disabled={!addData.values.level_id || isEditing} // ✅ Disable if no level selected
              />
            </div>
          </div>
        </>
      )}
      <div className="row">
        <div className="col-lg-6">
          <InputSelect
            label="discipline"
            name="discipline"
            id="discipline"
            options={enums?.data?.disciplines?.map((i) => ({
              label: trans(i),
              value: i,
            }))}
            placeholder={trans(`Select Discipline`)}
            formstyle="form-input"
            onBlur={(e) => addData.handleBlur(e)}
            onChange={(value) => addData.setFieldValue("discipline", value)}
            value={addData.values.discipline}
            allowClear={false}
            touched={addData.touched.discipline}
            errors={addData.errors.discipline}
            disabled={isEditing}
          />
        </div>
        <div className="col-lg-6">
          <InputSelect
            label="form"
            name="form_id"
            id="form_id"
            options={Forms?.data?.map((i) => ({
              label: i.name,
              value: i.id,
            }))}
            placeholder={trans(`Select Form`)}
            formstyle="form-input"
            onBlur={(e) => addData.handleBlur(e)}
            onChange={(value) => addData.setFieldValue("form_id", value)}
            value={addData.values.form_id}
            allowClear={false}
            touched={addData.touched.form_id}
            errors={addData.errors.form_id}
            disabled={isEditing}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6">
          <InputDate
            title={trans("Ready Date")}
            id="ready_date"
            name="ready_date"
            onBlur={(value) => addData.setFieldTouched("ready_date", true)}
            onChange={(value) => {
              const formattedDate = value
                ? dayjs(value).format("YYYY-MM-DD")
                : "";
              addData.setFieldValue("ready_date", formattedDate);
            }}
            errors={addData.errors.ready_date}
            touched={addData.touched.ready_date}
            value={addData.values.ready_date || ""}
            min={dayjs(Date.now()).add(1, "day")}
          />
        </div>
      </div>

      {/* Location Selector Modal */}
      <SnagLocationSelectorModal
        open={showLocationModal}
        onClose={() => setShowLocationModal(false)}
        onConfirm={handleLocationChange}
        preselectedValues={{
          project_id: addData.values.project_id,
          zone_id: addData.values.zone_id,
          building_id: addData.values.level_id,
        }}
      />
    </div>
  );
}
